import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

export const WeatherContainer = styled.section`
	/* display: flex; */
	/* flex-direction: column; */
	/* justify-content: center; */
	/* align-items: center; */
	background-color: #e0ec89;//var(--ion-color-step-150);
	/* padding: 3rem; */
	margin: 4rem 0;
`;

export const WeatherSwiper = styled(Swiper)`
	padding: 1rem;
`;

export const WeatherSwiperSlide = styled(SwiperSlide)`
	/* max-width: 33%; */
	max-width: 135px;
	aspect-ratio: 1/1;
	background: #257226;//var(--ion-color-secondary);
	padding: 0.5rem;
	color: #fff;
	text-align: center;
	border-radius: 5px;
	box-shadow: var(--generic-box-shadow);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	h3 {
		margin: 0;
	}

	p {
		margin: 0;
		font-size: 0.875rem;
		color: var(--ion-color-light);
	}

	svg {
		width: 32px;
		height: 32px;
		margin-bottom: 0.5rem;
		path {
			fill: #fff;
		}
	}
`;
